// src/components/HeaderTwo.js
import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Container, Row, Col, Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next'; // Import useTranslation hook
import StickyMenu from './common/StickyMenu';
import MobileMenu from './common/MobileMenu';
import { Styles } from "./styles/headerTwo.js";
import LanguageSelector from '../components/cozy/LanguageSelector';

class HeaderTwo extends Component {
    render() {
        return (
            <Styles>
                {/* Topbar 2 */}
                <section className="top-bar2">
                    <Container>
                        <Row>
                            <Col lg="7" md="9">
                                <div className="bar-left">
                                    <ul className="list-unstyled list-inline">
                                        <li className="list-inline-item"><i className="las la-phone"></i>+88 01710 668 174</li>
                                        <li className="list-inline-item"><i className="las la-envelope"></i>hello@cozycouture.com</li>
                                    </ul>
                                </div>
                            </Col>
                            <Col lg="5" md="3">
                                <div className="bar-right d-flex justify-content-end">
                                    {/* Sticky Menu */}
                                    <LanguageSelector />
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>

                {/* Logo Area 2 */}
                <section className="logo-area2">
                    <Container>
                        <Row>
                            <Col md="3">
                                <div className="logo">
                                    <Link to={process.env.PUBLIC_URL + "/"}><img src={process.env.PUBLIC_URL + "/assets/images/cozy_logo_3.svg"} alt="" /></Link>
                                </div>
                            </Col>
                            <Col md="9">
                                <div className="menu-box d-flex justify-content-end">
                                    <ul className="nav menu-nav">
                                        {/* Home */}
                                        <li className="nav-item">
                                            <NavLink exact activeClassName="active" className="nav-link" to={process.env.PUBLIC_URL + "/"}>Home</NavLink>
                                        </li>
                                        {/* About */}
                                        <li className="nav-item">
                                            <NavLink activeClassName="active" className="nav-link" to={process.env.PUBLIC_URL + "/about"}>About</NavLink>
                                        </li>
                                        {/* Products */}
                                        <li className="nav-item">
                                            <NavLink
                                                activeClassName="active"
                                                className="nav-link"
                                                to={process.env.PUBLIC_URL + "/product-category"}
                                                isActive={(match, location) => {
                                                    return location.pathname.includes("product");
                                                }}
                                            >
                                                Products
                                            </NavLink>
                                        </li>
                                        {/* Services */}
                                        <li className="nav-item">
                                            <NavLink activeClassName="active" className="nav-link" to={process.env.PUBLIC_URL + "/services"}>Services</NavLink>
                                        </li>
                                        {/* Clients */}
                                        <li className="nav-item">
                                            <NavLink activeClassName="active" className="nav-link" to={process.env.PUBLIC_URL + "/clients"}>Clients</NavLink>
                                        </li>
                                        {/* Contact */}
                                        <li className="nav-item">
                                            <NavLink activeClassName="active" className="nav-link" to={process.env.PUBLIC_URL + "/contact"}>Contact</NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>

                {/* Sticky Menu */}
                <StickyMenu />

                {/* Mobile Menu */}
                <MobileMenu />
            </Styles>
        )
    }
}

export default HeaderTwo;